export const ApiUrl = () => {
    return process.env.REACT_APP_BASE_URL
}
export const header = {"Authorization" : `Bearer ${localStorage.getItem("reestr-token")}`};
export const Multipartheader = {
    "Authorization" : `Bearer ${localStorage.getItem("reestr-token")}`,
    "Content-Type" : "multipart/form-data"
};
